module.exports = __webpack_public_path__ + "img/erweima.37e3d316.png";